/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverwolfXPTransactionGame
 */
export interface OverwolfXPTransactionGame {
    /**
     * 
     * @type {string}
     * @memberof OverwolfXPTransactionGame
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof OverwolfXPTransactionGame
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof OverwolfXPTransactionGame
     */
    title?: string;
    /**
     * Playtime source — "pc" (Overwolf), "playstation", or "xbox" (Discord presence).
     * @type {string}
     * @memberof OverwolfXPTransactionGame
     */
    platform?: string;
    /**
     * The amount of time played in minutes.
     * @type {number}
     * @memberof OverwolfXPTransactionGame
     */
    timePlayed?: number;
}

/**
 * Check if a given object implements the OverwolfXPTransactionGame interface.
 */
export function instanceOfOverwolfXPTransactionGame(value: object): value is OverwolfXPTransactionGame {
    return true;
}

export function OverwolfXPTransactionGameFromJSON(json: any): OverwolfXPTransactionGame {
    return OverwolfXPTransactionGameFromJSONTyped(json, false);
}

export function OverwolfXPTransactionGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverwolfXPTransactionGame {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'image': json['image'] == null ? undefined : json['image'],
        'title': json['title'] == null ? undefined : json['title'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'timePlayed': json['timePlayed'] == null ? undefined : json['timePlayed'],
    };
}

export function OverwolfXPTransactionGameToJSON(json: any): OverwolfXPTransactionGame {
    return OverwolfXPTransactionGameToJSONTyped(json, false);
}

export function OverwolfXPTransactionGameToJSONTyped(value?: OverwolfXPTransactionGame | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'image': value['image'],
        'title': value['title'],
        'platform': value['platform'],
        'timePlayed': value['timePlayed'],
    };
}

